export default __webpack_public_path__ + "static/media/PGQ 76.457ad35b.docx";